import { BaseClient, IActionResponse, IActionResult } from "../";
import { ApiParams, IPagedResult } from "../../../assets/utils/lib";
import { ViewProps } from "../../../components/account/user/props";
import { GridUserDto, SearchUserDto, UserDto } from "../../dto";
import { UserChangePasswordDto } from "../../../assets/utils/lib/userChangePasswordDto";

export interface RequestAccountDeletionFormValues {
    name: string;
    email: string;
    reason?: string | undefined;
}

export class UserClient extends BaseClient {
    routes = ["account", "User"];

    async getUserAsync(id?: string | undefined): Promise<UserDto> {
        const actions: string[] = ["GetUser"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: UserDto = await this.getAsync<UserDto>(actions, params);
        return result;
    }

    async searchUsersAsync(payload: SearchUserDto | undefined): Promise<IPagedResult<GridUserDto>> {
        const actions: string[] = ["SearchUsers"];
        const result: IPagedResult<GridUserDto> = await this.postAsync<SearchUserDto, GridUserDto, IPagedResult<GridUserDto>>(actions, payload);
        return result;
    }

    async saveUserAsync(payload?: UserDto | undefined): Promise<IActionResult<UserDto>> {
        const actions: string[] = ["SaveUser"];
        return await this.postAsync<UserDto>(actions, payload);
    }

    async deleteUser(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteUser"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        return await this.deleteAsync(actions, params);
    }

    async deActivateUserAsync(id: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeActivateUser"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];
        return await this.deleteAsync(actions, params);
    }

    async getLookupsAsync(): Promise<ViewProps.UserLookupProps> {
        const actions: string[] = ["GetLookups"];
        const result: ViewProps.UserLookupProps = await this.getAsync<ViewProps.UserLookupProps>(actions, []);
        return result;
    }

    async resetPasswordAsync(payload: { userId: string | undefined }) {
        const actions: string[] = ["ResetPassword"];
        return await this.postAsync<{ userId: string | undefined }>(actions, payload);
    }

    async unlockUserAsync(payload: { userId: string | undefined }) {
        const actions: string[] = ["UnlockUser"];
        return await this.postAsync<{ userId: string | undefined }>(actions, payload);
    }

    async resendEmailAsync(payload: { userId: string | undefined, returnUrl: string }) {
        const actions: string[] = ["ResendConfirmationEmail"];
        return await this.postAsync<{ userId: string | undefined, returnUrl: string }>(actions, payload);
    }

    async changePasswordAsync(payload?: UserChangePasswordDto | undefined) {
        const actions: string[] = ["ChangePassword"];
        return await this.postAsync<UserChangePasswordDto>(actions, payload);
    }

    async enableUserAsync(payload: { userId: string | undefined }) {
        const actions: string[] = ["EnableUser"];
        return await this.postAsync<{ userId: string | undefined }>(actions, payload);
    }

    async submitRequestAccountDeletionForm(
        payload: RequestAccountDeletionFormValues | undefined
    ): Promise<IActionResult<RequestAccountDeletionFormValues>> {
        const actions: string[] = ["SubmitRequestAccountDeletionForm"];
        return await this.postAsync<RequestAccountDeletionFormValues>(actions, payload);
    }
}